module.exports = __webpack_public_path__ + "static/media/logo3.0be4d735.png";